// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ff-0";
export var optionCard = "_ff-1";